import Core6Utilities from './Core6Utilities';

export default class Core6PagedSliderPublic {
  constructor() {
    this.transitionInterval = null;
  }

  initPagedSliders() {
    Core6PagedSliderPublic.initialiseContainer();
    Core6PagedSliderPublic.showSlide(0);
    Core6PagedSliderPublic.createNavigator();
    Core6PagedSliderPublic.highlightCurrentDot(0);
    $(document.body).on('click', '.pagedSliderDot', Core6PagedSliderPublic.onDotClicked);
    $(document.body).on('click', '.pagedSliderPrevArrow', Core6PagedSliderPublic.onPreviousClicked);
    $(document.body).on('click', '.pagedSliderNextArrow', Core6PagedSliderPublic.onNextClicked);
    $(document.body).on('mouseenter', '.pagedSliderContainer', Core6PagedSliderPublic.pauseSlider);
    $(document.body).on('mouseleave', '.pagedSliderContainer', this.startTransition.bind(this));
  }

  static initialiseContainer() {
    const firstPagedSlider = Core6Utilities.getJQueryElement('.core6-mainrow-container.pagedsliderblock')[0];

    const pagedSliderContainer = $(document.createElement('div'));
    pagedSliderContainer.addClass('pagedSliderContainer');
    pagedSliderContainer.css('height', `${$(firstPagedSlider).outerHeight() }px`);
    pagedSliderContainer.css('overflow', 'none');
    pagedSliderContainer.css('position', 'relative');

    $(pagedSliderContainer).insertBefore(firstPagedSlider);

    const allPagedSliders = Core6Utilities.getJQueryElement('.core6-mainrow-container.pagedsliderblock');
    allPagedSliders.css('position', 'absolute');
    allPagedSliders.css('left', '0');
    allPagedSliders.css('right', '0');
    allPagedSliders.css('top', '0');
    allPagedSliders.css('bottom', '0');
    allPagedSliders.appendTo($(pagedSliderContainer));
  }

  static getLastIndex() {
    const allPagedSliders = Core6Utilities.getJQueryElement('.core6-mainrow-container.pagedsliderblock');
    return allPagedSliders.length - 1;
  }

  static getCurrentSlide() {
    return Core6Utilities.getJQueryElement('.core6-mainrow-container.pagedsliderblock:visible');
  }

  static getCurrentSlideIndex() {
    const allPagedSliders = Core6Utilities.getJQueryElement('.core6-mainrow-container.pagedsliderblock');
    const currentSlide = Core6Utilities.getJQueryElement('.core6-mainrow-container.pagedsliderblock:visible');

    const sliderCount = allPagedSliders.length;
    for (let i = 0; i < sliderCount; i += 1) {
      const thisSlide = $(allPagedSliders[i]);
      if (thisSlide.attr('data-row-id') === currentSlide.attr('data-row-id')) {
        console.log(`returning slide ${i} as the selected slide`);
        return i;
      }
    }
    return false;
  }

  static getNextSlide() {
    const currentSlide = Core6PagedSliderPublic.getCurrentSlideIndex();
    const lastSlide = Core6PagedSliderPublic.getLastIndex();

    if (currentSlide + 1 > lastSlide) {
      return 0;
    }
    return currentSlide + 1;
  }

  static showSlide(slideIndex) {
    const allPagedSliders = Core6Utilities.getJQueryElement('.core6-mainrow-container.pagedsliderblock');

    const sliderCount = allPagedSliders.length;
    for (let i = 0; i < sliderCount; i += 1) {
      const thisSlide = $(allPagedSliders[i]);
      if (i === (slideIndex * 1)) {
        thisSlide.show();
      } else {
        thisSlide.hide();
      }
    }
  }

  static fadeSlide(slideIndex, fadeDuration) {
    const currentSlideIndex = Core6PagedSliderPublic.getCurrentSlideIndex();
    const allPagedSliders = Core6Utilities.getJQueryElement('.core6-mainrow-container.pagedsliderblock');

    let fadeInSlide = null;
    let fadeOutSlide = null;

    const sliderCount = allPagedSliders.length;
    for (let i = 0; i < sliderCount; i += 1) {
      const thisSlide = $(allPagedSliders[i]);
      if (i === (slideIndex * 1)) {
        fadeInSlide = thisSlide;
      } else if (i === (currentSlideIndex * 1)) {
        fadeOutSlide = thisSlide;
      } else {
        thisSlide.hide();
      }
    }

    fadeInSlide.fadeIn(fadeDuration * 1);
    fadeOutSlide.fadeOut(fadeDuration * 1);
  }

  static createNavigator() {
    const slideCount = Core6PagedSliderPublic.getLastIndex();
    const navigator = $(document.createElement('div'));
    navigator.addClass('pagedSliderDotContainer');

    const prevArrow = $(document.createElement('div'));
    prevArrow.addClass('pagedSliderPrevArrow');
    prevArrow.html('<i class="fa fa-caret-left" aria-hidden="true"></i>');
    navigator.append(prevArrow);

    for ( let i = 0; i <= slideCount; i += 1 ) {
      const dot = $(document.createElement('div'));
      dot.addClass('pagedSliderDot');
      dot.attr('data-dot-index', i);
      navigator.append(dot);
    }

    const nextArrow = $(document.createElement('div'));
    nextArrow.addClass('pagedSliderNextArrow');
    nextArrow.html('<i class="fa fa-caret-right" aria-hidden="true"></i>');
    navigator.append(nextArrow);

    $('.pagedSliderContainer').append(navigator);
  }

  static highlightCurrentDot(nextSlide) {
    $('.pagedSliderDot').removeClass('selected');
    console.log('highlighting dot ' + nextSlide);
    $('.pagedSliderDot[data-dot-index='+nextSlide+']').addClass('selected');
  }

  static onDotClicked(e) {
    const clickedDot = $(e.currentTarget);

    const index = clickedDot.attr('data-dot-index');
    console.log(index);

    $(document).trigger('pagedSliderDotClicked', []);

    const allPagedSliders = Core6Utilities.getJQueryElement('.core6-mainrow-container.pagedsliderblock');
    allPagedSliders.stop();
    allPagedSliders.css('opacity', 1);

    Core6PagedSliderPublic.showSlide(index);
    Core6PagedSliderPublic.highlightCurrentDot(index);
  }

  static onPreviousClicked(e) {
    $(document).trigger('pagedSliderDotClicked', []);
    const allPagedSliders = Core6Utilities.getJQueryElement('.core6-mainrow-container.pagedsliderblock');
    allPagedSliders.stop();
    allPagedSliders.css('opacity', 1);

    let index = 0;
    const currentSlide = Core6PagedSliderPublic.getCurrentSlideIndex();
    const lastSlide = Core6PagedSliderPublic.getLastIndex();
    if ( currentSlide - 1 >= 0 ) {
      index = currentSlide - 1;
    } else {
      index = lastSlide;
    }

    Core6PagedSliderPublic.showSlide(index);
    Core6PagedSliderPublic.highlightCurrentDot(index);

  }

  static onNextClicked(e) {
    $(document).trigger('pagedSliderDotClicked', []);
    const allPagedSliders = Core6Utilities.getJQueryElement('.core6-mainrow-container.pagedsliderblock');
    allPagedSliders.stop();
    allPagedSliders.css('opacity', 1);

    let index = 0;
    const currentSlide = Core6PagedSliderPublic.getCurrentSlideIndex();
    const lastSlide = Core6PagedSliderPublic.getLastIndex();
    console.log('currentSlide: ' + currentSlide);
    console.log('lastSlide: ' + lastSlide);
    if ( currentSlide + 1 <= lastSlide ) {
      console.log('adding 1:' + currentSlide);
      index = currentSlide + 1;
      console.log('adding 1 done:' + index);
    }

    Core6PagedSliderPublic.showSlide(index);
    Core6PagedSliderPublic.highlightCurrentDot(index);
  }

  static pauseSlider() {
    console.log('pause transition');
    $(document).trigger('pagedSliderDotClicked', []);
    const allPagedSliders = Core6Utilities.getJQueryElement('.core6-mainrow-container.pagedsliderblock');
    allPagedSliders.stop();
    allPagedSliders.css('opacity', 1);
  }

  startTransition() {
    console.log('start transition');
    const currentSlide = Core6PagedSliderPublic.getCurrentSlide();
    const animationType = currentSlide.attr('data-transition');
    const animationTransitionDuration = currentSlide.attr('data-fade_transition_speed');
    const animationInterval = currentSlide.attr('data-scroll_time') * 1000;

    $(document).on('pagedSliderDotClicked', () => {
      clearInterval(this.transitionInterval);
    });

    if (animationInterval > 0) {
      this.transitionInterval = setInterval(
        () => {
          const nextSlide = Core6PagedSliderPublic.getNextSlide();
          if (animationType === 'none') {
            Core6PagedSliderPublic.showSlide(nextSlide);
          } else if (animationType === 'fade') {
            Core6PagedSliderPublic.fadeSlide(nextSlide, animationTransitionDuration);
          }
          Core6PagedSliderPublic.highlightCurrentDot(nextSlide);
        },
        animationInterval,
      );
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/core6/Core6PagedSliderPublic.js